import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationHandler = () => {
  const location = useLocation();

  useEffect(() => {
    // Reset body overflow on every navigation
    document.body.style.overflow = '';
    
    // Scroll to top
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default NavigationHandler; 